import Navbar from '../features/Navbar'
import PromoBanner from '../features/PromoBanner'
import Hero from '../features/landing/Hero'
import Tools from '../features/landing/Tools'
import Features from '../features/landing/Features'
import Faq from '../features/landing/Faq'
import CallToAction from '../features/landing/CallToAction'
import Footer from '../features/landing/Footer'

const Home = () => {
  return (
    <div className="w-full">
      <Navbar />
      <PromoBanner />
      <Hero />
      <Tools />
      <Features />
      <Faq />
      <CallToAction />
      <Footer />
    </div>
  )
}

export default Home